// BARCINO - Page FAQ : sommaire flottant + scroll-spy des categories
const barcinoFaq = {
    _root: null,
    _content: null,
    _categories: [],
    _accordion_handlers: [],
    _toggle_handlers: [],
    _link_handlers: [],
    _observer: null,
    _scroll_handler: null,
    _resize_handler: null,
    _raf: null,

    init() {
        this.destroy();
        this._root = document.querySelector('.bc-faq-anchor');
        this._content = document.querySelector('[data-faq-content]');
        if (!this._root) return;

        const toggleBtns = this._root.querySelectorAll('[data-faq-anchor-toggle]');
        const panel = this._root.querySelector('[data-faq-anchor-panel]');
        const links = this._root.querySelectorAll('[data-faq-anchor-link]');
        const indexEl = this._root.querySelector('[data-faq-anchor-index]');
        const labelEl = this._root.querySelector('[data-faq-anchor-label]');
        const mainToggle = this._root.querySelector('[data-faq-anchor-toggle]');
        this._categories = Array.from(document.querySelectorAll('[data-faq-category]'));
        const accordionSummaries = document.querySelectorAll('.bc-faq-accordion > summary');

        const setOpen = (open) => {
            this._root.classList.toggle('is-open', open);
            mainToggle?.setAttribute('aria-expanded', String(open));
            panel?.setAttribute('aria-hidden', String(!open));
        };

        const setActive = (link) => {
            const index = Array.from(links).indexOf(link) + 1;
            if (indexEl) indexEl.textContent = String(index).padStart(2, '0');
            if (labelEl) labelEl.textContent = link.querySelector('.bc-faq-anchor__item-label')?.textContent ?? '';

            links.forEach((item) => {
                const active = item === link;
                item.classList.toggle('is-active', active);
                if (active) {
                    item.setAttribute('aria-current', 'true');
                } else {
                    item.removeAttribute('aria-current');
                }
            });
        };

        toggleBtns.forEach((btn) => {
            const handler = () => setOpen(!this._root.classList.contains('is-open'));
            btn.addEventListener('click', handler);
            this._toggle_handlers.push({ el: btn, fn: handler });
        });

        links.forEach((link) => {
            const handler = (event) => {
                event.preventDefault();
                const targetId = link.getAttribute('data-target');
                const target = document.getElementById(targetId);
                setOpen(false);
                if (!target) return;

                const offset = 120;
                const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top, behavior: 'smooth' });
            };
            link.addEventListener('click', handler);
            this._link_handlers.push({ el: link, fn: handler });
        });

        accordionSummaries.forEach((summary) => {
            const handler = (event) => {
                const details = summary.parentElement;
                if (!details || details.tagName !== 'DETAILS') return;

                event.preventDefault();
                details.open = !details.open;
            };

            summary.addEventListener('click', handler);
            this._accordion_handlers.push({ el: summary, fn: handler });
        });

        if (this._categories.length && 'IntersectionObserver' in window) {
            this._observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    const link = this._root.querySelector(`[data-target="${entry.target.id}"]`);
                    if (link) setActive(link);
                });
            }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

            this._categories.forEach((category) => this._observer.observe(category));
        }

        const updateVisibility = () => {
            if (!this._root || !this._content || !this._categories.length) return;

            const first = this._categories[0];
            const last = this._categories[this._categories.length - 1];
            const firstTop = first.getBoundingClientRect().top;
            const lastBottom = last.getBoundingClientRect().bottom;
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const isDesktop = window.matchMedia('(min-width: 993px)').matches;
            const visible = isDesktop && firstTop <= viewportHeight * .72 && lastBottom >= 160;

            this._root.classList.toggle('is-visible', visible);
            this._root.setAttribute('aria-hidden', String(!visible));

            if (!visible) {
                setOpen(false);
            }
        };

        const requestVisibilityUpdate = () => {
            if (this._raf) return;
            this._raf = window.requestAnimationFrame(() => {
                this._raf = null;
                updateVisibility();
            });
        };

        this._scroll_handler = requestVisibilityUpdate;
        this._resize_handler = requestVisibilityUpdate;
        window.addEventListener('scroll', this._scroll_handler, { passive: true });
        window.addEventListener('resize', this._resize_handler);
        requestVisibilityUpdate();
    },

    destroy() {
        this._toggle_handlers.forEach(({ el, fn }) => el.removeEventListener('click', fn));
        this._link_handlers.forEach(({ el, fn }) => el.removeEventListener('click', fn));
        this._accordion_handlers.forEach(({ el, fn }) => el.removeEventListener('click', fn));
        this._accordion_handlers = [];
        this._toggle_handlers = [];
        this._link_handlers = [];

        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }

        if (this._scroll_handler) window.removeEventListener('scroll', this._scroll_handler);
        if (this._resize_handler) window.removeEventListener('resize', this._resize_handler);
        if (this._raf) {
            window.cancelAnimationFrame(this._raf);
            this._raf = null;
        }

        this._scroll_handler = null;
        this._resize_handler = null;
        this._root = null;
        this._content = null;
        this._categories = [];
    },
};

export default barcinoFaq;
